/* "Look inside" (drag to reveal + hotspots + cards) and "A day under your hat" (hours slider).
   Works for every instance on a page, including ones added later: window.HatsyInside.init(element). */
(function () {
  if (window.HatsyInside) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Look inside ---------- */
  function initLook(stage) {
    if (stage.__pi) return; stage.__pi = true;
    var box = stage.closest('.pi__grid') || stage.parentNode;
    var handle = stage.querySelector('[data-pi-handle]'), hint = stage.querySelector('[data-pi-hint]');
    var spots = [].slice.call(stage.querySelectorAll('.pi__spot')), cards = [].slice.call(box.querySelectorAll('.pi__card'));
    var p = 14, touched = false, dragging = false;
    function setP(v) {
      p = Math.max(4, Math.min(96, v));
      stage.style.setProperty('--p', p + '%');
      if (handle) handle.setAttribute('aria-valuenow', Math.round(p));
      spots.forEach(function (s) { s.classList.toggle('is-shown', parseFloat(s.style.left) < p - 3); });
      stage.classList.toggle('is-open', p > 55);
    }
    function fromEvent(e) { var r = stage.getBoundingClientRect(); var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left; return x / r.width * 100; }
    function start(e) { dragging = true; touched = true; if (hint) hint.classList.add('is-gone'); stage.classList.add('is-drag'); setP(fromEvent(e)); }
    function move(e) { if (!dragging) return; if (e.cancelable && e.touches) e.preventDefault(); setP(fromEvent(e)); }
    function end() { dragging = false; stage.classList.remove('is-drag'); }
    stage.addEventListener('pointerdown', function (e) { if (e.target.closest('.pi__spot')) return; stage.setPointerCapture && stage.setPointerCapture(e.pointerId); start(e); });
    stage.addEventListener('pointermove', move);
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    if (handle) handle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { setP(p + 6); touched = true; e.preventDefault(); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { setP(p - 6); touched = true; e.preventDefault(); }
    });
    setP(p);
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        var t0 = null;
        function step(ts) { if (touched) return; if (!t0) t0 = ts; var k = (ts - t0) / 1400; if (k > 1) { setP(14); return; } setP(14 + Math.sin(k * Math.PI) * 22); requestAnimationFrame(step); }
        setTimeout(function () { requestAnimationFrame(step); }, 400);
      }, { threshold: .5 });
      io.observe(stage);
    }
    function pick(n) {
      spots.forEach(function (s) { s.classList.toggle('is-on', s.dataset.spot === n); });
      cards.forEach(function (c) { var on = c.dataset.card === n; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on); });
      var s = spots.filter(function (x) { return x.dataset.spot === n; })[0];
      if (s && !s.classList.contains('is-shown')) { touched = true; if (hint) hint.classList.add('is-gone'); setP(Math.max(p, parseFloat(s.style.left) + 12)); }
    }
    spots.forEach(function (s) { s.addEventListener('click', function () { pick(s.dataset.spot); var c = cards.filter(function (x) { return x.dataset.card === s.dataset.spot; })[0]; if (c && window.innerWidth < 900) c.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }); });
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        var wasOpen = c.classList.contains('is-open');
        cards.forEach(function (x) { x.classList.remove('is-open'); if (x.hasAttribute('aria-expanded')) x.setAttribute('aria-expanded', 'false'); });
        if (c.hasAttribute('aria-expanded') && !wasOpen) { c.classList.add('is-open'); c.setAttribute('aria-expanded', 'true'); }
        pick(c.dataset.card);
      });
    });
    /* desktop: the first card starts open, so the detail is already showing */
    if (window.innerWidth >= 900 && cards[0] && cards[0].hasAttribute('aria-expanded')) {
      cards[0].classList.add('is-open', 'is-on'); cards[0].setAttribute('aria-expanded', 'true'); cards[0].setAttribute('aria-pressed', 'true');
      spots.forEach(function (s) { s.classList.toggle('is-on', s.dataset.spot === cards[0].dataset.card); });
    }
  }

  /* ---------- A day under your hat ---------- */
  function initDay(day) {
    if (day.__pi) return; day.__pi = true;
    var range = day.querySelector('[data-day-range]'), bubble = day.querySelector('[data-day-bubble]');
    if (!range) return;
    var M = {}; day.querySelectorAll('[data-m]').forEach(function (el) { M[el.dataset.m] = el; });
    var stC = day.querySelector('[data-state="c"]'), stS = day.querySelector('[data-state="s"]');
    var clamp = function (v) { return Math.max(4, Math.min(96, v)); };
    function render(h) {
      var pct = h / 12 * 100;
      M.cf.style.width = clamp(14 + h * 6.8) + '%'; M.ch.style.width = clamp(10 + h * 6.2) + '%'; M.cm.style.width = clamp(8 + h * 7.2) + '%';
      M.sf.style.width = clamp(6 + h * 0.9) + '%'; M.sh.style.width = clamp(8 + h * 1.6) + '%'; M.sm.style.width = clamp(6 + h * 1.1) + '%';
      var hrs = Math.round(h);
      bubble.textContent = h < 0.5 ? 'just put on' : hrs + (hrs === 1 ? ' hour in' : ' hours in');
      bubble.style.left = pct + '%';
      range.style.setProperty('--fill', pct + '%');
      stC.textContent = h < 2 ? 'feels fine at first' : h < 5 ? 'starting to rub and heat up' : 'frizz, a damp scalp, a hot forehead';
      stS.textContent = h < 2 ? 'smooth and comfortable' : h < 5 ? 'still smooth and cool' : 'still smooth, cool and dry';
    }
    var moved = false;
    range.addEventListener('input', function () { moved = true; render(+range.value); });
    render(0);
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        var t0 = null;
        function step(ts) { if (moved) return; if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / 1800); var h = 6 * (1 - Math.pow(1 - k, 3)); range.value = h; render(h); if (k < 1) requestAnimationFrame(step); }
        setTimeout(function () { requestAnimationFrame(step); }, 300);
      }, { threshold: .5 });
      io.observe(day);
    } else { range.value = 6; render(6); }
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-pi-stage]').forEach(initLook);
    scope.querySelectorAll('[data-pi-day]').forEach(initDay);
  }
  window.HatsyInside = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
